"use client";
import React from "react";
import { Benefit } from "../types/synergyTypes";
import styles from "./General.module.css";

interface BenefitsGridProps {
  benefits: Benefit[];
}

const BenefitsGrid: React.FC<BenefitsGridProps> = ({ benefits }) => (
  <section className={`bg-white px-4 py-16 md:px-8`}>
    <div className={`max-w-6xl mx-auto grid grid-cols-1 gap-6 md:gap-0 md:grid-cols-2 ${styles.tableBenefits}`}>
      {benefits.map((benefit) => (
        <div
          key={benefit.title}
          className={`p-6 md:p-20 rounded-[20px] md:rounded-[0px] border md:border-none border-gray-300 flex flex-col items-start min-h-[180px] ${styles.singleBenefit}`}
        >
          {benefit.img && (
            <img
              src={benefit.img}
              alt={benefit.title}
              className="w-[200px] md:w-[250px] h-auto object-contain m-auto mb-[15px] md:mb-[25px]"
            />
          )}
          <h3 className="text-[24px] md:text-[32px] max-w-[350px] text-center font-semibold mb-[15px] md:mb-[25px] mx-auto">{benefit.title}</h3>
          <p className="max-w-[350px] text-neutral-500 text-sm md:text-base text-center mx-auto">{benefit.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default BenefitsGrid; 